import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';
import mirroringReducer from '../routes/mirroring/redux';
import mirroringEpic from '../routes/mirroring/epic';
import fetchAccessLayerReducer from '../core/components/FetchAccessLayer/redux';
import fetchAccessLayerEpic from '../core/components/FetchAccessLayer/epic';

export const rootReducer = combineReducers({
  mirroring: mirroringReducer,
  fetchAccessLayer: fetchAccessLayerReducer,
});

export const rootEpic = combineEpics(...mirroringEpic, ...fetchAccessLayerEpic);
